var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("BlockUI Sample")]),_c('button',{on:{"click":_vm.blockUI}},[_vm._v("blockUI")]),_c('BlockUI',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBlock),expression:"isBlock"}],attrs:{"message":"Welcome to Your Vue.js App"}},[_c('img',{attrs:{"src":require("@/assets/images/cmmnBG/tenor.gif"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }